import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import AdminChat from 'components/Chat/AdminChat';
import CPPChat from 'components/Patient/CPPChat';
import { useAppSelector } from 'careand-redux/store';
import { usePathParams } from 'components/Navigation/NavStack';
import AssistantChat from 'components/Chat/AssistantChat';
import AssistantChatManager from 'components/Chat/AssistantChatManager';
import { useAppDispatch } from '../../../careand-redux/useAppDispatch';
import { uiActions } from '../../../careand-redux/slices/ui/ui';

const ChatOverlays = ({ onArchive }) => {
  const role = useAppSelector((state) => state.authentication.role);
  return (
    <>
      {role === 'admin' && <AdminChats onArchive={onArchive} />}
      {role === 'physician' && <PhysicianChats onArchive={onArchive} />}
    </>
  );
};

const AdminChats = ({ onArchive }) => {
  const assistant = useAppSelector((state) => state.ui.openAssistantId);
  const patients = useAppSelector((state) => state.patients.byId);
  const { bubbles, activeBubble } = useAppSelector((state) => state.ui);
  const activeChatId = activeBubble?.id;

  const { visibleChat, patientChats } = useMemo(() => {
    let patientChats = [];
    let visibleChat = false;

    bubbles
      .filter(({ helpdesk }) => !helpdesk)
      .forEach((bubble) => {
        let visible = isVisible(bubble, activeChatId);
        if (visible === true) visibleChat = true;
        if (patients[bubble.patient_id]) {
          let newBubble = { ...bubble };
          patientChats.push(newBubble);
        }
      });

    return { visibleChat, patientChats };
  }, [bubbles, patients, activeChatId]);

  let className = 'overlay admin';
  if (!visibleChat && !assistant) className += ' hide';

  return (
    <div className={className}>
      <AssistantChatManager />
      {patientChats.map((bubble) => {
        let visible = !!activeChatId && bubble.id === activeChatId;
        return (
          <AdminChat
            key={bubble.id}
            bubble={visible ? activeBubble : bubble}
            onArchive={onArchive}
            visible={visible}
          />
        );
      })}
    </div>
  );
};

const PhysicianChats = ({ onArchive }) => {
  const params = usePathParams();
  const { bubbles, activeBubble, assistant } = useAppSelector((state) => state.ui);
  const patients = useAppSelector((state) => state.patients.byId);
  const activeChatId = activeBubble?.id || params.bubbleId;
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(uiActions.setActiveBubbleId(params.bubbleId));
  }, [params.bubbleId, dispatch]);

  const patientChats = useMemo(() => {
    let patientChats = [];
    bubbles
      .filter(({ helpdesk }) => !helpdesk)
      .forEach((bubble) => {
        if (patients[bubble.patient_id]) patientChats.push(bubble);
      });

    return patientChats;
  }, [bubbles, patients]);

  let className = 'overlay physician';
  if (!activeChatId && !assistant) className += ' hide';

  return (
    <div className={className}>
      {patientChats.map((bubble) => {
        let visible = isVisible(bubble, activeChatId);
        return visible ? (
          <CPPChat key={bubble.id || bubble.patient_id} bubble={bubble} onArchive={onArchive} />
        ) : null;
      })}
    </div>
  );
};

function isVisible(bubble, activeChatId) {
  return activeChatId !== undefined && bubble.id === activeChatId;
}

ChatOverlays.propTypes = {
  onArchive: PropTypes.func.isRequired,
};

export default ChatOverlays;
